import React, { useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';
import Field from '../Field';
import Toast from '../../molecules/Toast';
import jobService from '../../../services/jobService';
import CenterModal from '../../molecules/Modal/CenterModal';
import Loaders from '../Loaders';
import { LeadsDataStyle } from '../CreateCompaign/CreateCompaign.styles';

const ImportJobsLeadsData = ({
  addLeadsDataTab,
  setAddLeadsDataTab,
  csvInfo,
  setOpenLeadsModal,
  onSuccess,
  data,
  isInLeadsStep,
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);


  const dataList = [
    { value: `${csvInfo?.totalContacts}`, subtitle: 'Contacts in Lists' },
    {
      value: `${csvInfo?.hasMappedEmail
        ? csvInfo?.totalEmails || 0
        : csvInfo?.uniqueRowsCount || csvInfo?.uniqueRowsByMapping?.length || 0
        }`,
      subtitle: csvInfo?.hasMappedEmail ? 'E-Mails found' : 'Companies found',
    },
    { value: `${csvInfo?.duplicateCountByMapping || 0}`, subtitle: 'Duplicates inside List' },
    // { value: `${csvInfo?.duplicateEmails?.length || 0}`, subtitle: 'Duplicates from other Lists' },
    { value: `0`, subtitle: 'Duplicates from other Lists' },

    { value: `${csvInfo?.blockedEmails?.length || 0}`, subtitle: 'Blocklisted Domains' },
  ];

  const handleSubmit = async e => {
    try {
      setLoading(true);
      const payload = {
        name: data?.step1?.list_name,
        leadList: data?.step2?.leadList,
        leads_type: 'csv_leads',
        tagId: data?.step1?.tag,
        includeDuplicates: e?.checkbox1,
      };

      const res = await jobService?.addLeadsToJob(payload);
      if (res.success) {
        Toast({ type: 'success', message: 'Import Job Created Successfully' });
        onSuccess?.();
      }
    } catch (err) {
      Toast({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  function handleBack() {
    setAddLeadsDataTab('mapping');
  }

  function handleCancel() {
    setOpenLeadsModal(false);

    setAddLeadsDataTab('leads');
  }
  return (
    <>
      <CenterModal open={loading} setOpen={setLoading} width="600" noHead>
        <div className="leads-modal">
          <strong className="heading">Processing your leads...</strong>
          <p>CSV file has many leads, so this may take some time ⏳</p>
          <Loaders dotsLoader dotsBottom />
        </div>
      </CenterModal>
      <LeadsDataStyle>
        <Form form={form} onSubmit={handleSubmit}>
          <div className="content-wrap">
            <div className="head">
              <strong className="heading">Let's start with the basics</strong>
              <p>Name your campaign and select where your leads will come from.</p>
            </div>

            {/* ✅ Render dynamically from array */}
            <div className="data-holder">
              {dataList?.map((item, index) => (
                <div className="data-col" key={index}>
                  <strong className="value">{item.value || 0}</strong>
                  <span className={`subtitle ${item.subtitle === 'Duplicates from other Lists' ? 'disabled' : ''}`}>
                    {item.subtitle}
                  </span>
                </div>
              ))}
            </div>

            <div className="checkbox-wrap">
              <Form.Item
                className="check-text"
                type="checkbox"
                rounded
                name="checkbox1"
                label="Update Duplicates from other lists">
                <Field />
              </Form.Item>

              <Form.Item
                className="check-text"
                type="checkbox"
                rounded
                disabled={true}
                name="checkbox2"
                label="Include Leads from other Team Members">
                <Field />
              </Form.Item>
            </div>
          </div>
          <div className="btn-holder">
            <Button newStyle rounded variant="outline" width="155px" type="button" onClick={() => handleBack()}>
              Back
            </Button>
            <div className="btn-wrap">
              <Button rounded newStyle variant="outline" width="155px" type="button" onClick={() => handleCancel()}>
                Cancel
              </Button>
              <Button newStyle rounded variant="darkBlue" type="submit" width="155px" loader={loading} disabled={loading}>
                {addLeadsDataTab ? 'Import' : 'Finish'}
              </Button>
            </div>
          </div>
        </Form>
      </LeadsDataStyle>
    </>
  );
};

export default ImportJobsLeadsData;
